import axios from 'axios'
import {objToParams} from '../utils/objToParams'
import * as T from './types'

/**
 * Default headers untuk request ke API
 */
export const headers = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
  'Access-Control-Allow-Origin': '*',
  apikey: '1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw',
  Authorization: `Bearer ${localStorage.getItem('token')}`,
}

const api_masterdata = axios.create({
  headers,
  baseURL: process.env.REACT_APP_PI_BACKEND_API_MASTERDATA,
})

const api_masterdata_v2 = axios.create({
  headers,
  baseURL: (process.env.REACT_APP_PI_BACKEND_API_MASTERDATA_V2)
})

const api_management = axios.create({
  headers,
  baseURL: process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT,
})

const api_management2 = axios.create({
  headers,
  baseURL: process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT_V2,
})

const api_h2h = axios.create({
  headers,
  baseURL: process.env.REACT_APP_PI_BACKEND_API_H2H,
})

const api_sap = axios.create({
  headers,
  baseURL: process.env.REACT_APP_PI_BACKEND_API_SAP,
})

const api_auth = axios.create({
  headers,
  baseURL: process.env.REACT_APP_PI_BACKEND_API,
})

/**
 * Fetcher untuk mendapatkan data price jbp
 */
export const getPriceJbpSearch = (params: T.IGetPriceJbpSearchParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/price-list/jbp?${objToParams(params)}`
  return api_masterdata.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data findoc
 */
export const searchFindoc = (params?: T.ISerchFindocParams) => {
  const token = localStorage.getItem('token') as string
  const credentials = localStorage.getItem('credential') as string
  const endpoint = `/findoc?credentials=${credentials}&${objToParams(params)}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data end users
 */
export const getEndUsers = (params?: T.IEndUserParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/enduser?${objToParams(params)}`
  return api_masterdata.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data SIP
 * @deprecated duplicate with getSIP gunakan fetchSIPOrders
 */
export const getSIP = (params?: T.IGetSIPParams) => {
  const token = localStorage.getItem('token') as string
  const credentials = localStorage.getItem('credential') as string
  const endpoint = `/sip_order?credentials=${credentials}&${objToParams(params)}`
  return api_management.get(endpoint, {
    headers: {...headers, Authorization: `Bearer ${token}`},
  })
}

/**
 * Fetcher untuk mendapatkan data SIP Order
 */
export const fetchSIPOrders = (params: any) => {
  const token = localStorage.getItem('token') as string
  const credentials = localStorage.getItem('credential') as string
  const queryString = new URLSearchParams(params).toString();
  const endpoint = `/sip_order?credentials=${credentials}&${queryString}`
  return api_management.get(endpoint, {
    headers: {...headers, Authorization: `Bearer ${token}`},
  })
}

export const fetchHistorySIP = (id: number, params: any = null) => {
  const token = localStorage.getItem('token') as string
  const credentials = localStorage.getItem('credential') as string
  const queryParams = params ? `?${objToParams(params)}` : ''
  const endpoint = `/sip_order/get-history/${id}${queryParams}`
  return api_management.get(endpoint, {
    headers: {...headers, Authorization: `Bearer ${token}`, 'X-credentials': credentials},
  })
}

/**
 * Fetcher untuk mendapatkan data PO Approved
 */
export const fetchPOApproved = (params?: T.IFetchPOApprovedParams) => {
  const token = localStorage.getItem('token') as string
  const credentials = localStorage.getItem('credential') as string
  const endpoint = `/sip_order/po-number-approved?credentials=${credentials}&${objToParams(params)}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data role
 * @deprecated duplicate with fetchRoles
 */
export const fetchRole = (params?: T.IFetchRoleParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/role?${objToParams(params)}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data configuration letter
 */
export const fetchConfigLetter = (params?: T.IFetchConfigLetterParams) => {
  const token = localStorage.getItem('token') as string
  const credentials = localStorage.getItem('credential') as string
  const endpoint = `/config/letter?credentials=${credentials}&${objToParams(params)}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

export const fetchConfigOptionalText = (params?: any) => {
  const token = localStorage.getItem('token') as string
  const credentials = localStorage.getItem('credential') as string
  const endpoint = `/config/additional-text?credentials=${credentials}&${objToParams(params)}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data configuration signing
 */
export const fetchConfigSigning = (params?: T.IFetchConfigSigningParams) => {
  const token = localStorage.getItem('token') as string
  const credentials = localStorage.getItem('credential') as string
  const endpoint = `/config/signing?credentials=${credentials}&${objToParams(params)}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

export const fetchConfigPaymentDueDate = (params?: T.IFetchConfigSigningParams) => {
  const token = localStorage.getItem('token') as string
  const credentials = localStorage.getItem('credential') as string
  const endpoint = `/config/date-config/payment-due-date?credentials=${credentials}&${objToParams(params)}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

export const fetchConfigFile = (params?: T.IFetchConfigSigningParams) => {
  const token = localStorage.getItem('token') as string
  const credentials = localStorage.getItem('credential') as string
  const endpoint = `/file-configuration?credentials=${credentials}&${objToParams(params)}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fethcer untuk mendapatkan data log API
 */
export const fetchLogAPI = (params?: T.IFetchLogAPIParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/log/api?${objToParams(params)}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

export const fetchLogSalesOrder = (params?: T.IFetchLogSalesOrderParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/log/sales-order?${objToParams(params)}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fethcer untuk mendapatkan data log Peruri
 */
export const fetchLogPeruri = (params?: T.IFetchLogAPIParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/log/api?${objToParams(params)}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fethcer untuk mendapatkan data log H2H
 */
export const fetchLogH2H = (params?: T.IFetchLogH2HParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/log-h2h?${objToParams(params)}`
  return api_h2h.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fethcer untuk mendapatkan data log SAP
 */
export const fetchLogSAP = (params?: T.IFetchLogSAPParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/log?${objToParams(params)}`
  return api_sap.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data log master data
 */
export const fetchLogMasterData = (params?: T.IFetchLogMasterDataParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/log/api?${objToParams(params)}`
  return api_masterdata.get(endpoint, {
    headers: {...headers, Authorization: `Bearer ${token}`},
  })
}

/**
 * Fetcher untuk mendapatkan data log master data
 */
export const fetchLogAuth = (params?: T.IFetchLogParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/log/api?${objToParams(params)}`
  return api_auth.get(endpoint, {
    headers: {...headers, Authorization: `Bearer ${token}`},
  })
}

/**
 * Fetcher untuk mendapatkan data log antrian
 */
export const fetchLogQueue = (params?: T.IFetchLogParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/log/queue?${objToParams(params)}`
  return api_masterdata_v2.get(endpoint, {
    headers: {...headers, Authorization: `Bearer ${token}`},
  })
}

/**
 * Fetcher untuk mendapatkan data config date
 */
export const fetchConfigDate = (params?: T.IFetchMasterSupplyPoint) => {
  const token = localStorage.getItem('token') as string
  const credentials = localStorage.getItem('credential') as string
  const endpoint = `/config/date-config/pickup-date?credentials=${credentials}&${objToParams(params)}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

export const fetchSupplyPoint = (params?: T.IFetchConfigDateParams) => {
  const token = localStorage.getItem('token') as string
  const credentials = localStorage.getItem('credential') as string
  const endpoint = `/supply-point?credentials=${credentials}&${objToParams(params)}`
  return api_masterdata.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

export const exportSupplyPoint = (filter: any) => {
  const credentials = localStorage.getItem('credential') as string
  const queryString = new URLSearchParams(filter).toString();
  return api_masterdata.get(`/supply-point/export?credentials=${credentials}&${queryString}`, {
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

export const syncSupplyPoint = () => {
  const token = localStorage.getItem('token') as string
  const credentials = localStorage.getItem('credential') as string
  const endpoint = `/supply-point/sync`
  return api_masterdata.post(endpoint, {}, {
    headers: {
      ...headers, 
      Authorization: `Bearer ${token}`,
      'X-Credentials': credentials
    }
  })
}

/**
 * Fetcher untuk mendapatkan data level user
 */
export const fetchUserLevels = (params?: T.IFetchUserLevelParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/user-level?${objToParams(params)}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data level user
 */
export const fetchSettingConfig = (params?: T.IFetchUserLevelParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/config/setting/?${objToParams(params)}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data level user
 */
export const fetchUserLevelList = (params?: T.IFetchUserLevelListParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/user-level/list?${objToParams(params)}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan approval level user
 */
export const fetchApprovalLevelList = () => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/approval-level/list`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data contract level approval
 */
export const fetchContractLevels = (params?: T.IFetchApprovalLevelParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/approval-level/contract?${objToParams(params)}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data so level approval
 */
export const fetchSOLevels = (params?: T.IFetchApprovalLevelParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/approval-level/sales-order?${objToParams(params)}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data so level approval
 */
export const fetchSIPLevels = (params?: T.IFetchApprovalLevelParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/approval-level/sip?${objToParams(params)}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data PO level approval
 */
export const fetchPOLevels = (params?: T.IFetchApprovalLevelParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/approval-level/order?${objToParams(params)}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan product type
 */
export const fetchProductType = () => {
  const token = localStorage.getItem('token') as string
  const credentials = localStorage.getItem('credential') as string
  const endpoint = `/material-group/list?credentials=${credentials}`
  return api_masterdata.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data menu
 */
export const fetchMenus = (params: T.IFetchMenusParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/menu?${objToParams(params)}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data roles
 */
export const fetchRoles = (params?: T.IFetchRoleParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/role?${objToParams(params)}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data users
 */
export const fetchUsers = (params?: T.IFetchUsersParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/users?${objToParams(params)}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data users
 */
export const fetchRoutes = (params?: T.IFetchRoutesParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/route?${objToParams(params)}`
  return api_masterdata.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data bank keys
 */
export const fetchBankKeys = (params?: T.IFetchBankKeysParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/bank-key?${objToParams(params)}`
  return api_masterdata.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data bank accounts
 */
export const fetchBankAccounts = (params?: T.IFetchBankAccountsParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/bank/bank-account?${objToParams(params)}`
  return api_masterdata.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data order approval
 */
export const fetchOrderApproval = (checked: string | '&flag=1', params?: T.IFetchOrdersParams) => {
  const token = localStorage.getItem('token') as string
  const credentials = localStorage.getItem('credential') as string
  const endpoint = `/order-submission/get_otorisator?credentials=${credentials}&${objToParams(
    params
  )}${checked}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data so approval
 */
export const fetchSOApproval = (
  checked: string | '-approved',
  params?: T.IFetchSOApprovalParams
) => {
  const token = localStorage.getItem('token') as string
  const credentials = localStorage.getItem('credential') as string
  const endpoint = `/sales-order/get-otorisator${checked}?credentials=${credentials}&${objToParams(
    params
  )}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data sip approval
 */
export const fetchSIPApproval = (
  checked: string | '-approved',
  params?: T.IFetchSIPApprovalParams
) => {
  const token = localStorage.getItem('token') as string
  const credentials = localStorage.getItem('credential') as string
  const endpoint = `/sip_order/get-otorisator${checked}?credentials=${credentials}&${objToParams(
    params
  )}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data contract approval
 */
export const fetchContractApproval = (
  checked: string | '-approved',
  params?: T.IFetchContractApprovalParams
) => {
  const token = localStorage.getItem('token') as string
  const credentials = localStorage.getItem('credential') as string
  const endpoint = `/contract/get-otorisator${checked}?credentials=${credentials}&${objToParams(
    params
  )}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data sales order (SO)
 */
export const fetchSO = (params?: T.IFetchSOParams) => {
  const token = localStorage.getItem('token') as string
  const credentials = localStorage.getItem('credential') as string
  const endpoint = `/sales-order?credentials=${credentials}&${objToParams(params)}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data regions
 */
export const fetchRegions = () => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/regions`
  return api_masterdata.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data cities
 */
export const fetchCities = (params: {regions?: string}) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/cities?${objToParams(params)}`
  return api_masterdata.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data amandements
 */
export const fetchAmandements = (params?: T.IFetchAmandementParams) => {
  const token = localStorage.getItem('token') as string
  const credentials = localStorage.getItem('credential') as string
  const endpoint = `/amandemen/all?credentials=${credentials}&${objToParams(params)}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mandapatkan data orders
 */
export const fetchOrders = (params?: T.IFetchOrdersParams) => {
  const token = localStorage.getItem('token') as string
  const credentials = localStorage.getItem('credential') as string
  const endpoint = `/order-submission/all?credentials=${credentials}&${objToParams(params)}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mandapatkan data order contracts
 */
export const fetchContracts = (params?: T.IFetchOrderContractsParams) => {
  const token = localStorage.getItem('token') as string
  const credentials = localStorage.getItem('credential') as string
  const endpoint = `/contract?credentials=${credentials}&${objToParams(params)}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mandapatkan data invoices
 */
export const fetchInvoices = (params?: T.IFetchInvoiceParams) => {
  const token = localStorage.getItem('token') as string
  const credentials = localStorage.getItem('credential') as string
  const endpoint = `/invoice-sales-order?credentials=${credentials}&${objToParams(params)}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mandapatkan data materials
 */
export const fetchMaterials = (params?: T.IFetchMaterialParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/material-product/datatable?${objToParams(params)}`
  return api_masterdata.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mandapatkan data customers
 */
export const fetchCustomers = (params?: T.IFetchCustomerParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/customer?${objToParams(params)}`
  return api_masterdata.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data plant assignment
 */
export const fetcherPlantAssignment = (params?: T.IFetchPlantAssignmentParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/plant/assignment?${objToParams(params)}`
  return api_masterdata.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data plants
 */
export const fetcherPlants = (params?: T.IFetchPlantsParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/plant?${objToParams(params)}`
  return api_masterdata.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data sales offices
 */
export const fetchSalesOffices = (params?: T.IFetchSalesOffices) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/sales-office?${objToParams(params)}`
  return api_masterdata.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data sales area assignment
 */
export const fetchSalesAreaAssignment = (params?: T.IFetchSalesAreaAssignmentParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/sales-area-assignment?${objToParams(params)}`
  return api_masterdata.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data basic price list
 */
export const fetchBasicPrices = (params?: T.IFetchBasicPricesParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/price-list/dasar?${objToParams(params)}`
  return api_masterdata.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fether untuk mendapatkan data price non jbp
 */
export const fetchNonJBPPrices = (params?: T.IFetchNonJBPPricesParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/price-list/jbp?type=non-jbp&${objToParams(params)}`
  return api_masterdata.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data incoterms
 */
export const fetchIncoterms = (params?: T.IFetchIncotermsParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/incoterm?${objToParams(params)}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data term of payments
 */
export const fetchTermOfPayments = (params?: T.IFetchTermOfPaymentsParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/term-of-payment?${objToParams(params)}`
  return api_masterdata.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data transports
 */
export const fetchTransports = (params?: T.IFetchTransportsParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/transport-mode?${objToParams(params)}`
  return api_masterdata.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data news
 */
export const fetchNews = (params?: T.IFetchNewsParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/news?${objToParams(params)}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data audit trails
 */
export const fetchAuditTrails = (params?: T.IFetchAuditTrailsParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/audit-trail?${objToParams(params)}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data ppn
 */
export const fetchPPN = (params?: T.IFetchPPNParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/ppn?${objToParams(params)}`
  return api_masterdata.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data payment types
 */
export const fetchPaymentTypes = (params?: T.IFetchPaymentTypes) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/payment-type/list?${objToParams(params)}`
  return api_masterdata.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mendapatkan data material groups
 */
export const fetchMaterialGroups = (params?: T.IFetchMaterialGroupsParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/material-group/list?${objToParams(params)}`
  return api_masterdata.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk get data delivery orders
 */
export const fetchDeliveryOrders = (params?: T.IFetchDeliveryOrdersParams) => {
  const token = localStorage.getItem('token') as string
  const credentials = localStorage.getItem('credential') as string
  const endpoint = `/delivery-order?credentials=${credentials}&${objToParams(params)}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

export const syncDO = (params: any) => {
  const token = localStorage.getItem('token') as string
  const credentials = localStorage.getItem('credential') as string
  const endpoint = `/delivery-order/sync?credentials=${credentials}&${objToParams(params)}`
  return api_management.post(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fetcher untuk mengambil detail detail harga jbp
 */
export const fetchJBPPriceDetail = (params?: T.IFetchJBPPriceDetailParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/price-list/jbp/detail${objToParams(params)}`
  return api_masterdata.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Mutation untuk mengupdate data price jbp
 * @TODO: Pindahkan kedalam folder mutations
 */
export const mutateJBPPrice = (jbpId: number, payload: T.IMutateJBPPricePayload) => {
  const token = localStorage.getItem('token') as string
  const credentials = localStorage.getItem('credential') as string
  const endpoint = `/price-list/jbp/edit/${jbpId}?credentials=${credentials}`
  return api_masterdata.put(endpoint, payload, {
    headers: {...headers, Authorization: `Bearer ${token}`},
  })
}

/**
 * Fetcher untuk mengambil data attachments
 */
export const fetchAttachments = ({attachment_type, ...params}: T.IFetchAttacmentsParams) => {
  const token = localStorage.getItem('token') as string
  const credentials = localStorage.getItem('credential') as string
  const endpoint = `/attachment/all/${attachment_type}?credentials=${credentials}&${objToParams(
    params
  )}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fethcher untuk mengambil data notifikasi
 */
export const fetchNotifications = (params?: T.IFetchNotificationsParams) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/notification?${objToParams(params)}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fethcher untuk mengambil detail notifikasi
 */
export const fetchNotification = (id: number) => {
  const token = localStorage.getItem('token') as string
  const credentials = localStorage.getItem('credential') as string
  const endpoint = `/notification/detail/${id}?credentials=${credentials}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fethcher untuk mengambil data total notifikasi
 */
export const fetchNotificationAmount = ({credential}: {credential: string}) => {
  const token = localStorage.getItem('token') as string
  // const credentials = localStorage.getItem('credential') as string
  const endpoint = `/notification/amount-notif-is-not-Read?credentials=${credential}`
  return api_management.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

export const markAllNotificationAsRead = (
  credential: string,
  payload: any
) => {
  const token = localStorage.getItem('token') as string
  // const credentials = localStorage.getItem('credential') as string
  const endpoint = `/notification/mark-notifications-read?credentials=${credential}`
  return api_management.put(endpoint, payload, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

/**
 * Fethcher untuk mengambil data total notifikasi
 */
export const fetchSlocList = (params: T.IFetchSlocListParams) => {
  const token = localStorage.getItem('token') as string
  const credentials = localStorage.getItem('credential') as string
  const endpoint = `/sloc/list/id?${objToParams(params)}&credentials=${credentials}`
  return api_masterdata.get(endpoint, {headers: {...headers, Authorization: `Bearer ${token}`}})
}

export const fetchJbpTypes = (params: T.IFetchMasterJBPType) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/price-list/jbp-type?${objToParams({
    ...params,
    'X-Credentials': localStorage.getItem('credential')
  })}`
  return api_masterdata_v2.get(endpoint, {headers: {
    ...headers,
    Authorization: `Bearer ${token}`,
    'X-Credentials': localStorage.getItem('credential')
  }})
}

export const exportJbpTypes = (filter: any) => {
    const credentials = localStorage.getItem('credential') as string
    const queryString = new URLSearchParams(filter).toString();
    return api_masterdata_v2.get(`/price-list/jbp-type/export?credentials=${credentials}&${queryString}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    })
}

export const fetchCheckStock = (params: Record<string, any>) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/monitoring-stock`
  return api_management.get(endpoint, {
    params: params,
    headers: {
      ...headers,
      Authorization: `Bearer ${token}`,
      'X-Credentials': localStorage.getItem('credential'),
      'Content-Type': 'application/json'
    }
  })
}

export const fetchOutstandingSO = (params: Record<string, any>) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/sales-order/outstanding?${objToParams({
    ...params,
    'X-Credentials': localStorage.getItem('credential')
  })}`
  return api_management2.get(endpoint, {headers: {
    ...headers,
    Authorization: `Bearer ${token}`,
    'X-Credentials': localStorage.getItem('credential')
  }})
}

export const fetchJbps = (params: T.IFetchMasterJBP) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/price-list/jbp-config?${objToParams({
    ...params,
    credentials: localStorage.getItem('credential')
  })}`
  return api_masterdata_v2.get(endpoint, {headers: {
    ...headers,
    Authorization: `Bearer ${token}`,
    'X-Credentials': localStorage.getItem('credential')
  }})
}

export const fetchJbpPricings = (prefix: String, params: T.IFetchMasterJBP) => {
  const token = localStorage.getItem('token') as string
  const endpoint = `/price-list/pricing/${prefix}?${objToParams({
    ...params,
    credentials: localStorage.getItem('credential')
  })}`
  return api_masterdata_v2.get(endpoint, {headers: {...headers,
    Authorization: `Bearer ${token}`,
    credentials: localStorage.getItem('credential')
  }})
}

export const exportJbpPricings = (filter: any) => {
  const queryString = new URLSearchParams(filter).toString();
    return api_masterdata_v2.get(`/price-list/pricing/export?${queryString}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    })
}